import React from "react";
import { Link } from "react-router-dom";
import { FolioCabin } from "../app-template/AppContent";
import LandingContent from "./LandingContent";
import Screen from "./img/screen-iglu-cabin-selection.png";
import LogoIglu from "./img/logo-mono-iglu.svg";
import IconFaArrow from "../img/IconFaArrowR";

function LandingIgluCabin() {
	return (
		<section className="landing-card cs-cabins">
			<article className="block-content">
				<h2 className="title">{FolioCabin.caseStudy}</h2>
				<span className="category">{LandingContent.igluCabins.category}</span>
				{LandingContent.igluCabins.paras.map((p) => {
					return <p className="para">{p}</p>;
				})}
				<figure className="logo-block">
					<img className="logo-anthem" src={LogoIglu} alt="Iglu logo" />
				</figure>
			</article>
			<Link to={FolioCabin.path} className="block-link">
				<figure className="screen">
					<img src={Screen} alt="Eligibility application UI" />
				</figure>
				<i className="arrow-icon-circle">
					<IconFaArrow />
				</i>
				<i className="transparency pos01"></i>
				<i className="transparency pos02"></i>
				<i className="transparency pos03"></i>
			</Link>
		</section>
	);
}

export default LandingIgluCabin;
